export const environment = {
  production: false,
  apiUrl: 'https://mod-myrank-dev.myorder.dev/myrank',
};
